import { useRef } from "react"
import PassApi from "../../data/PassApi"
import { useOverlay } from "../../gui/Overlay/OverlayProvider"
import { IToggleButton } from "../../gui/Button/ToggleButton"
import Checkbox from "../../gui/Button/Checkbox"
import Button from "../../gui/Button/Button"

export default function LogoutDlg(){
    const {popOverlay} = useOverlay()
    const refDelete = useRef<IToggleButton|null>(null)
    const onClose = () => popOverlay("passwordDlg")
    const onConfirm = () => {
        onClose()
        if (refDelete.current?.checked) PassApi.i.clear()
        PassApi.i.logout()
    }
    return <>
        <h2>Logout</h2>
        <div className="content">
            <p>Delete local storage after logout?</p>
            <Checkbox ref={refDelete}>DELETE</Checkbox>
        </div>
        <div className="actions">
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained"onClick={onConfirm}>Okay</Button>
        </div>
    </>
}